export enum GatewayMenuItems {
  DETAILS = 'details',
  ADC = 'adc',
  MODBUS = 'modbus',
  GENERAL = 'general',
  FUNCTIONS = 'functions',
  SERVICES = 'services',
  LOGS = 'logs',
  IOT_LOGS = 'iot_logs',
  CONNECTIONS = 'connections',
  METADATA = 'metadata'
}
